<template>
  <component :is="inputComponent"
             :type="inputType"
             :field="field"
             :label="label"
             :hint="hint"
             :buttons="buttons"
             :stacked="stacked"
             :placeholder="placeholder" />
</template>

<script>
// import McCheckboxes from './mc-checkboxes'
// import McDate from './mc-date'
// import McFile from './mc-file'
// import McRadios from './mc-radios'
import McSelect from './mc-select'
import McString from './mc-string'
import McSwitch from './mc-switch'
import McRadioSlider from './mc-radio-slider'
// import McTextarea from './mc-textarea'

export default {
  components: {
    // McCheckboxes,
    // McDate,
    // McFile,
    // McRadios,
    McSelect,
    McString,
    McSwitch,
    McRadioSlider
    // McTextarea
  },
  props: {
    field: String,
    type: String,
    label: [Boolean, String],
    hint: String,
    buttons: Boolean,
    stacked: Boolean,
    placeholder: String,
  },
  created () {
    this.model = this.$parent.model
  },
  computed: {
    inputType () {
      // console.log('input type')
      // console.log(this.field)
      return this.type || this.model.fieldType(this.field)
    },
    inputComponent () {
      // console.log('input component')
      switch (this.inputType) {
        case 'boolean':
          return 'mc-switch'
        case 'checkboxes':
          return 'mc-checkboxes'
        case 'date':
          return 'mc-date'
        case 'file':
          return 'mc-file'
        case 'radios':
          return 'mc-radios'
        case 'radio-slider':
          return 'mc-radio-slider'
        case 'select':
          return 'mc-select'
        case 'textarea':
          return 'mc-textarea'
        case 'location':
          return 'mc-location'
        default:
          return 'mc-string'
      }
    }
  }
}
</script>

<style>
.form-group {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/fractel/components/vue-mc/form/mc-input.vue